import {
  SET_SHOW_PUBLISH,
  SET_IS_CART,
  SET_ORDER_OBJ,
  SET_TALKBAO_INDEX,
  SET_IMPRINT_INDEX,
  SET_SHOW_UPDATENUM,
  SET_FOCUS_ADDREMARK,
  SET_USER_INFO,
  SET_BOOTHSTORE_DETAIL,
  SET_ORDER_KEYID,
  SET_templateLibraryId,
  SET_IGET_SALESNUM,
  SET_IGET_UPDATESALESNUM,
  SET_BACK_WAITORDER,
  SET_ADD_REMARKTEXT,
  SET_ADD_REMARKOBJ,
  SET_VIDEO_SHOW,
  SET_VIDEO_SRC,
  SET_Home_POP,
  SET_PASSWORD_STATUS,
  SET_STORE_ID,
  SET_NFC_READTXT,
  SET_NFC_WRITETXT,
  SET_WRITE_STATE,
  SET_LAST_CHIP_UID,
  SET_REDIRECT_TO,
  SET_USER_GEO,
  CLEAR_REDIRECT_TO, SET_USER_ID,

  SET_IS_APP, SET_IS_WECHAT, SET_PAY_INFO, SET_APP_TYPE, SET_SHOP_CART_NUM,
  SET_ORDER_DATA, CLEAR_ORDER_DATA,
  SET_PERMISSIONS, CLEAR_PERMISSIONS,
  SET_PRODUCT_STOCK_FILTER,
  SET_VCONSOLE_ENABLED,
  SET_RESOURCE_ID,
} from './mutations-type'
import state from "./state";

/**
 * 📌 作用：唯一可以直接修改 state 的地方，必须是同步的
 * ✅ 如何使用 mutations 修改 state？
 * this.$store.commit('SET_USER_ID', 12345);
 */
export default {
  //新增或者已整理的
  [SET_USER_ID](state, data) {
    state.userId = Number(data); // 确保 userId 是数字类型
    localStorage.setItem('userId', state.userId); // 存入 localStorage
  },

  //未整理的

  updateTabActive(state, active) {
    state.active = active
  },
  setHintVisible(state, visible) {
    state.hintVisible = visible;
  },
  [SET_SHOW_PUBLISH](state, data) {
    state.showPublish = data;
  },
  [SET_IS_CART](state, data) {
    state.isCart = data;
  },
  [SET_ORDER_OBJ](state, data) {
    state.orderStateObj = data;
  },
  [SET_TALKBAO_INDEX](state, data) {
    state.talkbaoindex = data;
  },
  [SET_IMPRINT_INDEX](state, data) {
    state.imprintindex = data;
  },
  [SET_SHOW_UPDATENUM](state, data) {
    state.showUpdateNum = data;
  },
  [SET_FOCUS_ADDREMARK](state, data) {
    state.focusAddRemark = data;
  },
  //用户id
  [SET_USER_INFO](state, data) {
    localStorage.setItem('id', JSON.stringify(data))
    state.id = data;
  },
  //展台店铺详情
  [SET_BOOTHSTORE_DETAIL](state, data) {
    state.boothStoreDetail = data;
  },
  //订单主键ID
  [SET_ORDER_KEYID](state, data) {
    state.orderKeyId = data;
  },
  // 选择模板id
  [SET_templateLibraryId](state, data) {
    state.templateLibraryId = data;
  },
  // 我抢到的弹出框文本
  [SET_IGET_SALESNUM](state, data) {
    state.iGetSalesNum = data;
  },
  [SET_IGET_UPDATESALESNUM](state, data) {
    state.iGetUpdateSalesNum = data;
  },
  [SET_BACK_WAITORDER](state, data) {
    state.backWaitOrder = data;
  },
  [SET_ADD_REMARKTEXT](state, data) {
    state.addRemarkText = data;
  },
  [SET_ADD_REMARKOBJ](state, data) {
    state.addRemarkObj = data;
  },
  [SET_VIDEO_SHOW](state, data) {
    state.videoShow = data;
  },
  [SET_VIDEO_SRC](state, data) {
    state.videoSrc = data;
  },
  [SET_Home_POP](state, data) {
    state.homePop = data;
  },
  [SET_PASSWORD_STATUS](state, data) {
    state.passwordStatus = data
  },
  // 店铺id
  [SET_STORE_ID](state, data) {
    state.storeId = data
  },
  //nfc
  setNfcReadTxt(state, data) {
    state.nfcReadTxt = data
  },
  //setNfcWriteTxt
  setNfcWriteTxt(state, data) {
    state.nfcWriteTxt = data
  },
  [SET_NFC_READTXT](state, data) {
    state.nfcReadTxt = data
  },
  [SET_NFC_WRITETXT](state, data) {
    state.nfcWriteTxt = data
  },
  [SET_WRITE_STATE](state, data) {
    state.isWriteState = data
  },
  setUserGeo(state, data) {
    state.userGeo = data
  },
  [SET_USER_GEO](state, data) {
    state.userGeo = data
  },
  setLastChipUid(state, data) {
    state.lastChipUid = data
  },

  [SET_LAST_CHIP_UID](state, data) {
    state.lastChipUid = data
  },

//NFC
  SET_READ_MODE(state, status) {
    state.readMode = status;
  },
  SET_WRITE_MODE(state, status) {
    state.writeMode = status;
  },
  SET_PROCESSING(state, status) {
    state.isProcessing = status;
  },
  SET_MULTIPLE_WRITE(state, status) {
    state.multipleWrite = status;
  },

  SET_RESOURCE_ID(state, resourceId) {
    state.resourceId = resourceId;
    localStorage.setItem('resourceId', resourceId); // 同步到 localStorage
  },

  [SET_REDIRECT_TO](state, route) {
    state.redirectTo = route;
  },
  [CLEAR_REDIRECT_TO](state) {
    state.redirectTo = null;
  },

  // 保存当前页面 URL
  setRedirectTo(state, { path, query, params }) {
    state.redirectTo = { path, query, params };
  },

  [SET_IS_APP](state, status) {
    state.isApp = status;
  },
  [SET_IS_WECHAT](state, status) {
    state.isWechat = status;
  },
  [SET_PAY_INFO](state, payInfo) {
    state.payInfo = payInfo;
  },


  [SET_APP_TYPE](state, appType) {
    state.appType = appType;
  },
  [SET_SHOP_CART_NUM](state, num) {
    state.shopCartNum = num
  },

  // 订单数据管理
  [SET_ORDER_DATA](state, orderData) {
    state.orderData = orderData;
    // 同时存储到localStorage作为备份
    localStorage.setItem('orderData', JSON.stringify(orderData));
  },
  [CLEAR_ORDER_DATA](state) {
    state.orderData = null;
    localStorage.removeItem('orderData');
  },

  // 权限管理
  [SET_PERMISSIONS](state, permissions) {
    state.permissions = permissions || [];
    // 同时存储到localStorage作为备份
    localStorage.setItem('userPermissions', JSON.stringify(state.permissions));
  },
  [CLEAR_PERMISSIONS](state) {
    state.permissions = [];
    localStorage.removeItem('userPermissions');
  },

  // 店铺用户管理
  SET_STORE_USER(state, storeUser) {
    state.storeUser = storeUser || {};
    
    // 解析allowedButtons字符串到权限数组
    if (storeUser && storeUser.allowedButtons) {
      const permissions = storeUser.allowedButtons.split(',').map(p => p.trim());
      state.permissions = permissions;
      // 同时更新localStorage
      localStorage.setItem('userPermissions', JSON.stringify(permissions));
    }
  },

  // 设置资源ID
  [SET_RESOURCE_ID](state, resourceId) {
    state.resourceId = resourceId;
    localStorage.setItem('resourceId', resourceId);
  },

  // 设置商品库存筛选
  [SET_PRODUCT_STOCK_FILTER](state, filterType) {
    state.productStockFilter = filterType;
    localStorage.setItem('productStockFilter', filterType);
  },

  // vConsole调试开关
  [SET_VCONSOLE_ENABLED](state, enabled) {
    state.vConsoleEnabled = enabled;
    localStorage.setItem('vconsole_enabled', enabled ? 'true' : 'false');
    console.log('[vConsole] 状态已' + (enabled ? '开启' : '关闭') + '，刷新页面生效');
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js